import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

import styles from './FractionNumlineSlider.module.css'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '20px' }]
function FractionNumlineSlider({
  max,
  min,
  value,
  setValue,
  danger = false,
}: {
  max: number
  min: number
  value: number
  danger?: boolean
  setValue: (value: number) => void
}): React.ReactElement {
  const [partiTionLines, setPartiTionLines] = useState([0])
  const { t } = useTranslation('imageAlt')

  useEffect(() => {
    setPartiTionLines(new Array(max - min + 1).fill(0))
  }, [min, max])

  return (
    <>
      <div className="w-full flex justify-between mx-2">
        <div className="w-4 text-center">0</div>
        <div className="w-4 text-center">1</div>
        <div className="w-4 text-center">2</div>
      </div>
      <div className="w-full relative mx-4">
        <div className="bg-purple h-0.5 w-full absolute top-1/2" />
        <div className="flex w-full justify-between items-center">
          {partiTionLines.map((item, index) => {
            const isFullWidth = index / max === 0 || index / max === 0.5 || index / max === 1
            return <div className={`bg-purple ${isFullWidth ? 'h-8' : 'h-4'} w-0.5`} key={index.toString() + 1} />
          })}
        </div>
      </div>
      <div className="w-full h-6 relative mx-4 mt-2">
        <ResponsiveImage
          alt={t('purpleUpwardsArrow')}
          height={31}
          imageClassName="absolute"
          imageWidths="20"
          mediaQuery={mediaQuery}
          srcKey={danger ? 'bootcamp/arrow-up-red.png' : 'bootcamp/arrow-up.png'}
          style={{
            transform: 'translateX(-10px)',
            left: `${(value / max) * 100}%`,
          }}
          width={20}
        />
      </div>
      <div className="w-full mt-2">
        <input
          className={`${styles['numline-slider']} ${danger && styles['numline-slider-danger']}`}
          max={max}
          min={min}
          onChange={(e) => {
            setValue(parseInt(e.target.value))
          }}
          type="range"
          value={value}
        />
      </div>
    </>
  )
}

export default FractionNumlineSlider
